module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAKlBMVEUAfjoBfzsFgT4NhEQTiEkulV49nWlDoG5stY2Xyq+o07y+383SEDT3+/maYiRRAAAAMUlEQVQY02M4gwoYKOcfYIABHgRfNBmFz7IDVZ5rAipftwA/H109unno9iG7h6r+BQDL0qQ3wHnfZAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mv.png
// module id = 885
// module chunks = 0